<script lang="ts">
    import Tooltip from "../../lib/components/Tooltip.svelte";

    export let network: {
        type: string;
        quality: number;
    };

    // Цвет качества сигнала: 0 — серый, 1-2 — красный, 3 — жёлтый, 4 — зелёный.
    $: signalColor =
        network.quality >= 4
            ? "var(--success)"
            : network.quality >= 3
              ? "var(--warning)"
              : network.quality >= 1
                ? "var(--destructive)"
                : "var(--muted-foreground)";
</script>

<Tooltip
    content={"Сеть: " +
        network.type +
        (network.quality > 0
            ? "\nКачество сигнала: " + network.quality + "/4"
            : "")}
>
    <div class="inline-flex items-center gap-1">
        {#if network.type === "WIFI"}
            <!-- wifi icon -->
            <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke={signalColor}
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <path d="M5 13a10 10 0 0 1 14 0" />
                <path d="M8.5 16.5a5 5 0 0 1 7 0" />
                <path d="M2 8.82a15 15 0 0 1 20 0" />
                <line x1="12" y1="20" x2="12.01" y2="20" />
            </svg>
        {:else}
            <!-- bars (signal) icon — fill based on quality -->
            <svg width="14" height="14" viewBox="0 0 16 16">
                <rect
                    x="1"
                    y="11"
                    width="2.5"
                    height="4"
                    fill={network.quality >= 1 ? signalColor : "var(--border)"}
                />
                <rect
                    x="5"
                    y="8"
                    width="2.5"
                    height="7"
                    fill={network.quality >= 2 ? signalColor : "var(--border)"}
                />
                <rect
                    x="9"
                    y="5"
                    width="2.5"
                    height="10"
                    fill={network.quality >= 3 ? signalColor : "var(--border)"}
                />
                <rect
                    x="13"
                    y="2"
                    width="2.5"
                    height="13"
                    fill={network.quality >= 4 ? signalColor : "var(--border)"}
                />
            </svg>
        {/if}
        <span class="text-[var(--muted-foreground)] text-[11px] uppercase"
            >{network.type}</span
        >
    </div>
</Tooltip>
